<ngx-ui-loader text="please wait.." logoUrl="assets/images/atithilogo.webp"  fgsColor="#720000" pbColor="#720000 "></ngx-ui-loader>
<router-outlet></router-outlet>